var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    { attrs: { visible: "", width: "55%" }, on: { close: _vm.onCancel } },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _c("span", { staticClass: "font18" }, [
          _vm._v(
            _vm._s(
              _vm.initData.id ? _vm.$t("COMMON_EDIT") : _vm.$t("COMMON_ADD")
            )
          ),
        ]),
      ]),
      _c(
        "el-row",
        { staticClass: "mb-15" },
        [
          _c("el-col", { attrs: { span: 7 } }, [
            _c("i", { staticClass: "required-cls" }, [_vm._v("*")]),
            _vm._v(_vm._s(_vm.$t("admin.entityName"))),
          ]),
          _c(
            "el-col",
            { attrs: { span: 15 } },
            [
              _c("el-input", {
                model: {
                  value: _vm.entityName,
                  callback: function ($$v) {
                    _vm.entityName = $$v
                  },
                  expression: "entityName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "mb-15" },
        [
          _c("el-col", { attrs: { span: 7 } }, [
            _c("i", { staticClass: "required-cls" }, [_vm._v("*")]),
            _vm._v(_vm._s(_vm.$t("admin.signingDate"))),
          ]),
          _c(
            "el-col",
            { attrs: { span: 15 } },
            [
              _c("el-date-picker", {
                staticClass: "w-full",
                attrs: { type: "date", "value-format": "yyyy-MM-dd" },
                model: {
                  value: _vm.signingDate,
                  callback: function ($$v) {
                    _vm.signingDate = $$v
                  },
                  expression: "signingDate",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      this.type === "contract"
        ? _c(
            "el-row",
            { staticClass: "mb-15" },
            [
              _c("el-col", { attrs: { span: 7 } }, [
                _c("i", { staticClass: "required-cls" }, [_vm._v("*")]),
                _vm._v(_vm._s(_vm.$t("admin.contractType"))),
              ]),
              _c(
                "el-col",
                { attrs: { span: 15 } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w-full",
                      attrs: { placeholder: _vm.$t("admin.contractType") },
                      model: {
                        value: _vm.contractType,
                        callback: function ($$v) {
                          _vm.contractType = $$v
                        },
                        expression: "contractType",
                      },
                    },
                    _vm._l(_vm.categoryOptions, function (v, k) {
                      return _c("el-option", {
                        key: k,
                        attrs: { label: v.label, value: v.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "cancel-btn", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("comment_reSet")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { type: "primary", loading: _vm.saveLoading },
              on: { click: _vm.onConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("btn_save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }